import { BaseScopedTaskEventParams } from "@captions-web/dev-logger";

import { createEventDefs } from "../event-def";

export const AssetUploadEvents = createEventDefs<{
  status: BaseScopedTaskEventParams & {
    tracing_id: string;
    origin: string;
    file_id?: string;
  };
}>({
  namespacePrefix: "studio_asset_upload_",
});
